import { render } from "./PatientPrescriptionsGrid.vue?vue&type=template&id=59df919e"
import script from "./PatientPrescriptionsGrid.vue?vue&type=script&lang=js"
export * from "./PatientPrescriptionsGrid.vue?vue&type=script&lang=js"

import "./PatientPrescriptionsGrid.vue?vue&type=style&index=0&id=59df919e&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__